export const LOADER_STATUS = "boilerplate/ImsReco/Reconciliation/LOADER_STATUS";
export const RECO_TABLE_DATA = "boilerplate/ImsReco/Reconciliation/RECO_TABLE_DATA";
export const HISTORY_TABLE_DATA = "boilerplate/ImsReco/Reconciliation/HISTORY_TABLE_DATA";
export const SELECTED_RECO = "boilerplate/ImsReco/Reconciliation/SELECTED_RECO";
export const SELECTED_ROW_RECO = "boilerplate/ImsReco/Reconciliation/SELECTED_ROW_RECO";
export const SELECTED_HISTORY = "boilerplate/ImsReco/Reconciliation/SELECTED_HISTORY";
export const ACTION_SUMMARY_DATA = "boilerplate/ImsReco/Reconciliation/ACTION_SUMMARY_DATA";
export const UPLOAD_HISTORY_TOTAL_PAGES = "boilerplate/ImsReco/Reconciliation/UPLOAD_HISTORY_TOTAL_PAGES";


export const headerColumns = [
  {
    value: "Reco",
    id: "1",
  },
  {
    value: "Upload History",
    id: "2",
  },
];

// export const autoAccept = [
//   {
//     label: "All",
//     value: "select_all",
//     checked: false,
//     children: [
//       {
//         label: "Matched",
//         value: "Matched",
//       },
//       {
//         label: "Matched with tolerance",
//         value: "Matched with tolerance",
//       },
//       {
//         label: "Probable",
//         value: "Probable",
//       },
//     ],
//   },
// ];
// export const autoAccept =[
//       {
//         label: "Matched",
//         value: "Matched",
//       },
//       {
//         label: "Matched with tolerance",
//         value: "Matched with tolerance",
//       },
//       {
//         label: "Probable",
//         value: "Probable",
//       },
//     ]
export const autoAccept =[
{ id: "exact", label: "Exact Match" },
      { id: "exact_tol", label: "Exact Match with Tolerance" },
      { id: "probable", label: "Probable Match" },]